import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import DatePicker from 'react-datepicker';
import DataWrapper from "../../../principal/containers/DataWrapper";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";
import {getMotivoContratacaoById} from "../../../../utils/enums";
import {Validacao} from "../../../comum/components/Validacao";
import _ from 'lodash';
import ParametrosGeraisStore from "../../../administracao/stores/ParametrosGeraisStore";
import {Redirect} from "react-router-dom";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {DetalhamentoSolicitante} from "../../comum/components/DetalhamentoSolicitante";
import {DetalhamentoEmpregadosSubstituidos} from "../../comum/components/DetalhamentoEmpregadosSubstituidos";
import {DetalhamentoIndicacoes} from "../../comum/components/DetalhamentoIndicacoes";
import {DetalhamentoContato} from "../../comum/components/DetalhamentoContato";
import {DetalhamentoCargo} from "../../comum/components/DetalhamentoCargo";
import {DetalhamentoJustificativaExcecao} from "../../comum/components/DetalhamentoJustificativaExcecao";
import {DetalhamentoDebito} from "../../comum/components/DetalhamentoDebito";
import {DetalhamentoLocais} from "../../comum/components/DetalhamentoLocais";
import {DetalhamentoJustificativa} from "../../comum/components/DetalhamentoJustificativa";
import {DetalhamentoPrazos} from "../../comum/components/DetalhamentoPrazos";
import {DetalhamentoPerfil} from "../../comum/components/DetalhamentoPerfil";
import {DetalhamentoDadosMOT} from "../../solicitacao_ett/components/DetalhamentoDadosMOT";
import {DetalhamentoHistoricoFluxo} from "../../comum/components/DetalhamentoHistoricoFluxo";
import FluxoProrrogacaoStore from "../stores/FluxoProrrogacaoStore";
import {DataProrrogacao} from "../components/DataProrrogacao";
import {DetalhamentoProrrogacoesAnteriores} from "../../comum/components/DetalhamentoProrrogacoesAnteriores";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";
import {DebitoForm} from "../../../solicitacao/components/DebitoForm";

@inject("store")
@DataWrapper
@observer
export class SolicitacaoProrrogacao extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;
        this.parametrosGeraisStore = new ParametrosGeraisStore();

        this.controller = new FluxoProrrogacaoStore(this.parametrosGeraisStore, this.loginStore, this.tituloPaginaStore, this.validacaoStore, this.modalStore, this.loadingPanelStore);
    }

    componentDidMount() {
        this.controller.isSolicitacaoProrrogacao = true;
        this.tituloPaginaStore.setTitulo("Solicitação de prorrogação");

        const taskId = _.get(this.props, "match.params.taskIdBpm");
        const solicitacaoId = _.get(this.props, "match.params.solicitacaoId");
        const solicitacaoEttId = _.get(this.props, "match.params.solicitacaoEttId");
        const rota = _.get(this.props, "match.path");

        const dados = taskId ? {id: taskId, tipo: "tarefa"} : {solicitacaoId: solicitacaoId, solicitacaoEttId: solicitacaoEttId, tipo: "solicitacao"};

        dados.isFluxoNovo = true;
        if (rota === "/ajuste-prorrogacao/:taskIdBpm") {
            dados.isAjuste = true;
        }
        
        this.controller.carregarDados(dados);
        this.parametrosGeraisStore.carregarLista();
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };

    render() {
        if (this.formStore.acaoEnviada) {
            return <Redirect to="/contratacoes-vigentes" />;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        const desabilitarValidacao = this.validacaoStore.desabilitarValidacao;

        const possiveisAcoes = this.controller.isAjuste ? ["ENVIAR", "CANCELAR"] : ["PRORROGAR"];

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller} taskId={_.get(this.props, "match.params.taskIdBpm")} solicitacaoExcecao={this.controller.isSolicitacaoExcecao}
                                             tarefa={this.controller.nomeTarefa} fluxo={this.controller.nomeFluxo} possiveisAcoes={possiveisAcoes}
                                             error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    {this.controller.exibeJustificativaExcecao &&
                                        <DetalhamentoJustificativaExcecao />
                                    }
                                    <DetalhamentoSolicitante />
                                    <DetalhamentoContato desabilitarValidacao={desabilitarValidacao} />
                                    <DetalhamentoLocais />
                                    <DebitoForm />
                                    <DetalhamentoJustificativa isSolicitacaoProrrogacao={true}/>
                                    <DetalhamentoEmpregadosSubstituidos />
                                    <DetalhamentoPrazos />
                                    <DataProrrogacao editavel={true} />
                                    <DetalhamentoCargo />
                                    <DetalhamentoPerfil />
                                    {this.controller.exibeDetalhamentoDadosMOT &&
                                        <DetalhamentoDadosMOT desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    <DetalhamentoProrrogacoesAnteriores />
                                    {this.controller.exibeDetalhamentoHistorico &&
                                        <DetalhamentoHistoricoFluxo />
                                    }
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}